const makeHttpsUrl = (url) => {
    if (!url.match(/^(http|https):\/\//)) {
        url = "https://" + url;
    }
    return url;
};

export default makeHttpsUrl;